<template lang='pug' src='./nav-mobile.pug'></template>

<script>
import Icon from 'components/icon/icon'

import { toForm } from '@/methods'

export default {
  data () {
    return {
      active: false
    }
  },
  props: ['props'],
  computed: {
    links () {
      return this.$router.options.routes
    }
  },
  mixins: [toForm],
  components: {
    Icon
  },
  methods: {
    slideDrawer () {
      this.active = !this.active
      if (this.active) {
        document.body.classList.add('body-stop')
      }
      if (!this.active) {
        document.body.classList.remove('body-stop')
      }
    },
    closeDrawer () {
      this.active = false
      document.body.classList.remove('body-stop')
    },
    scrollHomeConsult () {
      this.$router.push('/invisalign')
      // wait for animation to finish before scrolling to element
      setTimeout(() => { this.$scrollTo('#section0') }, 500)
    },
    scrollHomeConsultt () {
      this.$router.push('/invisalign')
      // wait for animation to finish before scrolling to element
      setTimeout(() => { this.$scrollTo('#section1') }, 500)
    },
    scrollHomeConsulttt () {
      this.$router.push('/invisalign')
      // wait for animation to finish before scrolling to element
      setTimeout(() => { this.$scrollTo('#app') }, 500)
    }
  }
}

</script>



// WEBPACK FOOTER //
// nav-mobile.vue?1fc68393